export const IMPERSONATION_AUTH_MESSAGE_TYPE = "dental-os:impersonation-auth";

function clean(value) {
  const text = String(value || "").trim();
  return text || null;
}

function cleanReturnPath(value) {
  const text = clean(value);
  if (!text || !text.startsWith("/") || text.startsWith("//")) return "/";
  return text;
}

export function buildImpersonationAuthMessage(sessionId, session, options = {}) {
  const cleanedSessionId = clean(sessionId);
  const accessToken = clean(session?.access_token);

  if (!cleanedSessionId || !accessToken) return null;

  return {
    type: IMPERSONATION_AUTH_MESSAGE_TYPE,
    session_id: cleanedSessionId,
    access_token: accessToken,
    admin_return_path: cleanReturnPath(options.adminReturnPath),
  };
}

export function isImpersonationAuthMessage(message, sessionId) {
  return message?.type === IMPERSONATION_AUTH_MESSAGE_TYPE
    && clean(message.session_id) === clean(sessionId)
    && Boolean(clean(message.access_token));
}

export function readImpersonationAuthMessageFromHash(sessionId) {
  if (typeof window === "undefined") return null;

  const params = new URLSearchParams(String(window.location.hash || "").replace(/^#/, ""));
  const message = {
    type: IMPERSONATION_AUTH_MESSAGE_TYPE,
    session_id: params.get("impersonation_session_id"),
    access_token: params.get("admin_access_token"),
    admin_return_path: params.get("admin_return_path"),
  };

  return isImpersonationAuthMessage(message, sessionId)
    ? { ...message, admin_return_path: cleanReturnPath(message.admin_return_path) }
    : null;
}

export function waitForImpersonationAuthMessage(sessionId, timeoutMs = 2500) {
  if (typeof window === "undefined" || !window.opener) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    let done = false;
    const finish = (message) => {
      if (done) return;
      done = true;
      window.removeEventListener("message", onMessage);
      window.clearTimeout(timeout);
      resolve(message);
    };
    const onMessage = (event) => {
      if (event.source !== window.opener) return;
      if (!isImpersonationAuthMessage(event.data, sessionId)) return;
      finish({ ...event.data, admin_return_path: cleanReturnPath(event.data.admin_return_path) });
    };
    const timeout = window.setTimeout(() => finish(null), timeoutMs);
    window.addEventListener("message", onMessage);
    window.opener.postMessage({
      type: "dental-os:impersonation-auth-ready",
      session_id: clean(sessionId),
    }, "*");
  });
}
